import { useCallback, useEffect, useRef, useState } from 'react'

export const useAvailableActivitiesSelector = ({ availableActivities }) => {
  const [selectedRowsIds, setSelectedRowsIds] = useState({})
  const hasInitialized = useRef(false)

  const getSelectedCount = useCallback(
    (selectedRows = selectedRowsIds) =>
      Object.entries(selectedRows)
        .filter(([_, isSelected]) => isSelected)
        .map(([key, _]) => key).length,
    [selectedRowsIds]
  )

  const handleSelect = useCallback(
    (updatedSelectedRowsIds) => {
      setSelectedRowsIds(updatedSelectedRowsIds)
    },
    [setSelectedRowsIds]
  )

  const handleSelectAll = useCallback(() => {
    const selected = Object.fromEntries(
      Array(availableActivities.length)
        .keys()
        .map((index) => [index, true])
    )
    setSelectedRowsIds(selected)
  }, [setSelectedRowsIds, availableActivities])

  const handleDeselectAll = useCallback(() => {
    setSelectedRowsIds({})
  }, [setSelectedRowsIds])

  // Auto-select all on first load only
  useEffect(() => {
    if (availableActivities.length > 0 && !hasInitialized.current) {
      handleSelectAll()
      hasInitialized.current = true
    }
  }, [availableActivities, handleSelectAll])

  return {
    selectedRowsIds,
    getSelectedCount,
    handleSelect,
    handleSelectAll,
    handleDeselectAll,
  }
}
